import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import EmployeePerformancePage from "@/pages/employee/EmployeePerformancePage";

export const Route = createFileRoute("/employee/performance")({
  head: () => pageHead("Employee · Performance", "AKIVA employee · performance portal.", "/employee/performance", true),
  component: EmployeePerformancePage,
});
